module.exports = __webpack_public_path__ + "img/AZ.069fa0bc.png";